import { render, staticRenderFns } from "./wiefunktionierts.vue?vue&type=template&id=b6baf6ee&scoped=true&"
import script from "./wiefunktionierts.vue?vue&type=script&lang=js&"
export * from "./wiefunktionierts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6baf6ee",
  null
  
)

export default component.exports